/* tslint:disable */
/* eslint-disable */
/**
 * Task Service API
 * API for all task service endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ben@xp-lab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CountResponse
 */
export interface CountResponse {
    /**
     * The count of items
     * @type {number}
     * @memberof CountResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'error': string;
    /**
     * 
     * @type {TaskErrorCode}
     * @memberof ErrorResponse
     */
    'errorCode'?: TaskErrorCode;
}


/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * Task name (3-200 characters)
     * @type {string}
     * @memberof Task
     */
    'name': string;
    /**
     * Task body content (10-50000 characters)
     * @type {string}
     * @memberof Task
     */
    'body': string;
    /**
     * Short teaser text for the task (10-200 characters)
     * @type {string}
     * @memberof Task
     */
    'teaser': string;
    /**
     * Owner ID (1-50 characters, alphanumeric with hyphens and underscores)
     * @type {string}
     * @memberof Task
     */
    'ownerId'?: string;
    /**
     * 
     * @type {TaskLanguageEnum}
     * @memberof Task
     */
    'language': TaskLanguageEnum;
    /**
     * 
     * @type {TaskDifficultyEnum}
     * @memberof Task
     */
    'difficulty': TaskDifficultyEnum;
    /**
     * Task description (20-10000 characters)
     * @type {string}
     * @memberof Task
     */
    'description': string;
    /**
     * Default query for the task (1-2000 characters)
     * @type {string}
     * @memberof Task
     */
    'defaultQuery': string;
    /**
     * Data query for the task (1-2000 characters)
     * @type {string}
     * @memberof Task
     */
    'dataQuery': string;
    /**
     * Seed factor (0-100)
     * @type {number}
     * @memberof Task
     */
    'seedFactor': number;
    /**
     * JSON string containing feedback data for the task (2 characters minimum)
     * @type {string}
     * @memberof Task
     */
    'feedbackPayload'?: string;
    /**
     * JSON string containing data bank information for the task (2 characters minimum)
     * @type {string}
     * @memberof Task
     */
    'dataBank': string;
    /**
     * Access groups (1-10 unique groups, 1-50 characters each)
     * @type {Array<string>}
     * @memberof Task
     */
    'accessGroups': Array<string>;
    /**
     * Task proficiencies
     * @type {Array<TaskProficienciesEnum>}
     * @memberof Task
     */
    'proficiencies'?: Array<TaskProficienciesEnum>;
    /**
     * Solution placeholder for the task
     * @type {string}
     * @memberof Task
     */
    'solutionPlaceholder'?: string;
    /**
     * Availability weight for the task
     * @type {number}
     * @memberof Task
     */
    'availabilityWeight'?: number;
    /**
     * Whether the task is deleted
     * @type {boolean}
     * @memberof Task
     */
    'deleted'?: boolean;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof Task
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for challenges of this task; used instead of default when set
     * @type {number}
     * @memberof Task
     */
    'customQueryTimeout'?: number;
    /**
     * Human-readable URL-friendly identifier for the task
     * @type {string}
     * @memberof Task
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface TaskBase
 */
export interface TaskBase {
    /**
     * Task name (3-200 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'name': string;
    /**
     * Task body content (10-50000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'body': string;
    /**
     * Short teaser text for the task (10-200 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'teaser': string;
    /**
     * Owner ID (1-50 characters, alphanumeric with hyphens and underscores)
     * @type {string}
     * @memberof TaskBase
     */
    'ownerId'?: string;
    /**
     * 
     * @type {TaskLanguageEnum}
     * @memberof TaskBase
     */
    'language': TaskLanguageEnum;
    /**
     * 
     * @type {TaskDifficultyEnum}
     * @memberof TaskBase
     */
    'difficulty': TaskDifficultyEnum;
    /**
     * Task description (20-10000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'description': string;
    /**
     * Default query for the task (1-2000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'defaultQuery': string;
    /**
     * Data query for the task (1-2000 characters)
     * @type {string}
     * @memberof TaskBase
     */
    'dataQuery': string;
    /**
     * Seed factor (0-100)
     * @type {number}
     * @memberof TaskBase
     */
    'seedFactor': number;
    /**
     * JSON string containing feedback data for the task (2 characters minimum)
     * @type {string}
     * @memberof TaskBase
     */
    'feedbackPayload'?: string;
    /**
     * JSON string containing data bank information for the task (2 characters minimum)
     * @type {string}
     * @memberof TaskBase
     */
    'dataBank': string;
    /**
     * Access groups (1-10 unique groups, 1-50 characters each)
     * @type {Array<string>}
     * @memberof TaskBase
     */
    'accessGroups': Array<string>;
    /**
     * Task proficiencies
     * @type {Array<TaskProficienciesEnum>}
     * @memberof TaskBase
     */
    'proficiencies'?: Array<TaskProficienciesEnum>;
    /**
     * Solution placeholder for the task
     * @type {string}
     * @memberof TaskBase
     */
    'solutionPlaceholder'?: string;
    /**
     * Availability weight for the task
     * @type {number}
     * @memberof TaskBase
     */
    'availabilityWeight'?: number;
    /**
     * Whether the task is deleted
     * @type {boolean}
     * @memberof TaskBase
     */
    'deleted'?: boolean;
    /**
     * Optional name of a shared database to use instead of creating a per-challenge database
     * @type {string}
     * @memberof TaskBase
     */
    'sharedDBName'?: string;
    /**
     * Optional custom query timeout in seconds for challenges of this task; used instead of default when set
     * @type {number}
     * @memberof TaskBase
     */
    'customQueryTimeout'?: number;
    /**
     * Human-readable URL-friendly identifier for the task
     * @type {string}
     * @memberof TaskBase
     */
    'slug'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TaskDifficultyEnum = {
    Easy: 'Easy',
    Intermediate: 'Intermediate',
    Hard: 'Hard',
    Expert: 'Expert'
} as const;

export type TaskDifficultyEnum = typeof TaskDifficultyEnum[keyof typeof TaskDifficultyEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaskErrorCode = {
    TaskNotFound: 'taskNotFound',
    BadRequest: 'badRequest',
    InvalidTaskId: 'invalidTaskId'
} as const;

export type TaskErrorCode = typeof TaskErrorCode[keyof typeof TaskErrorCode];


/**
 * The programming language for the task or challenge
 * @export
 * @enum {string}
 */

export const TaskLanguageEnum = {
    Sql: 'SQL',
    Python: 'Python'
} as const;

export type TaskLanguageEnum = typeof TaskLanguageEnum[keyof typeof TaskLanguageEnum];


/**
 * Task proficiencies
 * @export
 * @enum {string}
 */

export const TaskProficienciesEnum = {
    Joins: 'joins',
    DataSanitization: 'dataSanitization',
    AnomalyDetection: 'anomalyDetection',
    TimeSeriesAnalysis: 'timeSeriesAnalysis',
    WindowFunctions: 'windowFunctions',
    Aggregation: 'aggregation'
} as const;

export type TaskProficienciesEnum = typeof TaskProficienciesEnum[keyof typeof TaskProficienciesEnum];



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get count of all tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idDelete', 'id', id)
            const localVarPath = `/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idGet', 'id', id)
            const localVarPath = `/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a task by ID
         * @param {string} id 
         * @param {TaskBase} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idPut: async (id: string, body: TaskBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('idPut', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('idPut', 'body', body)
            const localVarPath = `/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all tasks
         * @param {Array<string>} [accessGroups] 
         * @param {Array<string>} [ids] Array of task IDs to fetch. If provided, only tasks with matching IDs will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet: async (accessGroups?: Array<string>, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessGroups) {
                localVarQueryParameter['accessGroups'] = accessGroups.join(COLLECTION_FORMATS.csv);
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new task
         * @param {TaskBase} taskBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost: async (taskBase: TaskBase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskBase' is not null or undefined
            assertParamExists('rootPost', 'taskBase', taskBase)
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get count of all tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.countGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a task by ID
         * @param {string} id 
         * @param {TaskBase} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idPut(id: string, body: TaskBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idPut(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.idPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all tasks
         * @param {Array<string>} [accessGroups] 
         * @param {Array<string>} [ids] Array of task IDs to fetch. If provided, only tasks with matching IDs will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootGet(accessGroups?: Array<string>, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Task>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootGet(accessGroups, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new task
         * @param {TaskBase} taskBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootPost(taskBase: TaskBase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootPost(taskBase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.rootPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Get count of all tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countGet(options?: RawAxiosRequestConfig): AxiosPromise<CountResponse> {
            return localVarFp.countGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.idDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a task by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idGet(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Task> {
            return localVarFp.idGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a task by ID
         * @param {string} id 
         * @param {TaskBase} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idPut(id: string, body: TaskBase, options?: RawAxiosRequestConfig): AxiosPromise<Task> {
            return localVarFp.idPut(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all tasks
         * @param {Array<string>} [accessGroups] 
         * @param {Array<string>} [ids] Array of task IDs to fetch. If provided, only tasks with matching IDs will be returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootGet(accessGroups?: Array<string>, ids?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Task>> {
            return localVarFp.rootGet(accessGroups, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new task
         * @param {TaskBase} taskBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootPost(taskBase: TaskBase, options?: RawAxiosRequestConfig): AxiosPromise<Task> {
            return localVarFp.rootPost(taskBase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Get count of all tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public countGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).countGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a task by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idDelete(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a task by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idGet(id: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a task by ID
     * @param {string} id 
     * @param {TaskBase} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public idPut(id: string, body: TaskBase, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).idPut(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all tasks
     * @param {Array<string>} [accessGroups] 
     * @param {Array<string>} [ids] Array of task IDs to fetch. If provided, only tasks with matching IDs will be returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootGet(accessGroups?: Array<string>, ids?: Array<string>, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootGet(accessGroups, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new task
     * @param {TaskBase} taskBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootPost(taskBase: TaskBase, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootPost(taskBase, options).then((request) => request(this.axios, this.basePath));
    }
}



